<!-- Install App Modal -->
<div class="modal-backdrop fade show" *ngIf="visible"></div>
<div class="modal fade" id="installAppModal" [class.show]="visible" [style.display]="visible ? 'block' : 'none'">
  <div class="modal-dialog modal-dialog-centered" style="max-width: 400px;">
    <div class="modal-content">
      <div class="modal-header">
        <h5 *ngIf="context.os === 'windows' || context.os === 'macos' || context.os === 'linux'">
          Install App onto Your Computer</h5>
        <h5 *ngIf="context.os === 'android'">Install App onto Your Phone or Tablet</h5>
        <h5 *ngIf="context.os === 'ios'">Install App onto Your iPhone or iPad</h5>
        <!-- <h5 *ngIf="context.os === 'ios'">Install App onto your Device</h5> -->
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
          <span aria-hidden="true">×</span>
        </button>
      </div>

      <div class="modal-body">
        <!-- Chrome / Edge -->
        <div>
          <div class="popup-body-font">
            <div class="pwa-install-popup">
              <div class="pwa-benefits">
                <!-- <span style="margin-bottom: 10px;">{{isMobile ? 'Installing the app creates a home screen shortcut.':'Installing the app creates a
                  desktop shortcut.'}}
                </span> -->

                <div class="pwa-steps install-warning"
                  *ngIf="(context.browser === 'firefox' || context.browser === 'other' || (context.browser == 'chrome' && context.os == 'macos')); else showWarning">
                  <div *ngIf="(context.os === 'ios' || (context.browser == 'chrome' && context.os == 'macos')) && context.browser !== 'safari'">
                    <ol class="mb-0">
                      <li>Cable Pro Web can’t be installed using {{context.browser == 'chrome' ? 'Chrome' : 'Firefox'}}.
                      </li>
                      <li class="mb-0">
                        App installation is only supported in Safari for iPhone or iPad devices.
                      </li>
                    </ol>
                  </div>

                  <div id="firefox-steps" *ngIf="context.browser === 'firefox' && context.os != 'ios'">
                    <ol class="mb-0">
                      <li>Cable Pro Web can’t be installed using Firefox.</li>
                      <li class="mb-0">To install this app, use Chrome, Edge, or Safari.</li>
                    </ol>
                  </div>
                  <ol class="mb-0" id="default-steps" *ngIf="context.browser === 'other'">
                    <li>Look for <span>“Add to Home Screen”</span> in your browser menu</li>
                    <li class="mb-0">Confirm and the app will be saved like a regular app</li>
                  </ol>
                </div>
                <ng-template #showWarning>
                  <div class="pwa-steps install-box">
                    <span class="install-box-title ">How to Install:</span>
                    <!-- Chrome/Edge desktop -->
                    <ol class="mt-2"
                      *ngIf="(context.browser === 'chrome' || context.browser === 'edge') && (context.os === 'windows' || context.os === 'macos' || context.os === 'linux')">
                      <li>Click <span>“Install Now”</span>.</li>
                      <li>Select <span>“Install”</span> when prompted.</li>
                      <li>An app icon for <span>“ELEK Cable Pro Web”</span> will appear on your desktop and start menu.
                      </li>
                    </ol>
                    <!-- Chrome/Edge mobile (Android) -->
                    <ol class="mt-2"
                      *ngIf="(context.browser === 'chrome' || context.browser === 'edge') && context.os === 'android'">
                      <li>Tap <span>“Install Now”</span>.</li>
                      <li>Select <span>“Install” when prompted</span>.</li>
                      <li> An app icon for <span>“ELEK Cable Pro Web”</span> will appear on your
                        home screen and app drawer.</li>
                    </ol>
                    <!-- Safari macOS -->
                    <ol class="mt-2" *ngIf="(context.browser === 'safari') && context.os === 'macos'">
                      <!-- <span style="font-size:1.2rem;">:outbox_tray:</span> -->
                      <li>Click Share button (upper-right toolbar).</li>
                      <li>Select "Add to Dock".</li>
                      <li>Optionally rename the app, then click "Add".</li>
                      <li> An app icon for <span>"ELEK Cable Pro Web"</span> will appear on your Dock and Launchpad.
                      </li>
                    </ol>
                    <!-- Safari iOS -->
                    <ol class="mt-2" *ngIf="(context.browser === 'safari') && context.os === 'ios'">
                      <li>Click Share button (bottom toolbar).</li>
                      <li>Select "Add to Home Screen".</li>
                      <li>Optionally rename the app, then tap "Add".</li>
                      <li> An app icon for <span>"ELEK Cable Pro Web"</span> will appear on your home screen.</li>
                    </ol>
                    <ol class="mt-2" *ngIf="(context.browser === 'chrome') && context.os === 'ios'">
                      <li>Click Share button (upper-right toolbar).</li>
                      <li>Select "Add to Home Screen".</li>
                      <li>Optionally rename the app, then tap "Add".</li>
                      <li> An app icon for <span>"ELEK Cable Pro Web"</span> will appear on your home screen.</li>
                    </ol>
                  </div>
                </ng-template>
                <div class="pwa-steps benefits">
                  <span class="mb-2 install-box-title">Benefits:</span>
                  <ul class="mt-2">
                    <li>No need to open the browser.</li>
                    <li>Faster performance – loads instantly.</li>
                    <li>Automatic updates.</li>
                  </ul>
                </div>
              </div>


            </div>
          </div>
          <!-- <p class="popup-body-font" *ngIf="!pwa.canInstall">
            You have already installed the app.
          </p> -->
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="close()">Close</button>
        <button *ngIf="(context.browser === 'chrome' || context.browser === 'edge') && pwa.canInstall"
          class="btn btn-primary float-right" (click)="install()">
          Install Now
        </button>
      </div>
    </div>
  </div>
</div>